import React from 'react';
import {Button, Grid, Typography} from "@mui/material";
import useJoinUsStyles from "../../styles/kozelMeetBoardGameAccess/join_us";
import InfoIcon from "@mui/icons-material/Info";
import icon_arrow from '../../assets/images/icon_arrow.png';
import clsx from "clsx";
import {NavLink} from "react-router-dom";
import {paths} from "../../AppRouters";

const JoinUs: React.FC = () => {
    const styles = useJoinUsStyles();

    return (
        <Grid container className={styles.container}>
            <Grid item xs={12} lg={6} className={clsx(styles.item, styles.borderDottedBottom)}>
                <Typography className={styles.title}>EVEN MORE FUN?</Typography>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.subtitle}>Join Kozel Meeet community!﻿</Typography>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.text}>Create your account, invite your friends, win points and transform them in prizes and experiences for you and your group!</Typography>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <NavLink to={paths.register} className={styles.btn}>CREATE AN ACCOUNT</NavLink>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.textBenefits}><InfoIcon className={styles.contentTeaserListItemIcon}/>joining the community automatically brings you 50 points</Typography>
            </Grid>
            <img src={icon_arrow} alt={'arrow'} className={styles.arrow}/>
        </Grid>
    );
}

export default JoinUs;
